'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
var Eye = function Eye(props) {
  var color = props.color,
    size = props.size,
    otherProps = _objectWithoutProperties(props, ['color', 'size']);
  return _react2.default.createElement('svg', _extends({
    xmlns: 'http://www.w3.org/2000/svg',
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    strokeWidth: '1.5',
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  }, otherProps), _react2.default.createElement('path', {
    fill: color,
    d: 'M.33 11.665c.036-.074.103-.201.202-.376a20.245 20.245 0 0 1 2.796-3.802C5.8 4.849 8.7 3.25 12 3.25c3.3 0 6.2 1.6 8.672 4.237a20.245 20.245 0 0 1 2.796 3.802c.099.175.166.302.203.376a.75.75 0 0 1 0 .67 9.492 9.492 0 0 1-.203.376 20.245 20.245 0 0 1-2.796 3.802C18.2 19.151 15.3 20.75 12 20.75c-3.3 0-6.2-1.6-8.672-4.237a20.245 20.245 0 0 1-2.796-3.802 9.492 9.492 0 0 1-.203-.376.75.75 0 0 1 0-.67zm2.034 1.178a18.76 18.76 0 0 0 2.058 2.644C6.637 17.849 9.175 19.25 12 19.25s5.363-1.4 7.578-3.763A18.76 18.76 0 0 0 22.148 12a18.76 18.76 0 0 0-2.57-3.487C17.363 6.151 14.825 4.75 12 4.75s-5.363 1.4-7.578 3.763A18.76 18.76 0 0 0 1.852 12c.144.254.315.538.512.843zM12 15.75a3.75 3.75 0 1 1 0-7.5 3.75 3.75 0 0 1 0 7.5zm0-1.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5z',
    fillRule: 'evenodd'
  }));
};
Eye.propTypes = {
  color: _propTypes2.default.string,
  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
};
Eye.defaultProps = {
  color: 'currentColor',
  size: '24'
};
exports.default = Eye;